import {ButtonLink, ButtonProps} from 'components/Button';
import {links} from 'global.config';
import React from 'react';

type Props = ButtonProps & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export const EurmButton: React.FC<Props> = (props) => {
  return <ButtonLink {...props} href={links.eurm} />;
};
